<template>
  <v-app>
    <v-content class="y-full">
      <router-view/>
    </v-content>
  </v-app>
</template>

<script>

export default {
  name: 'app'
}
</script>
